import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentModule } from './document/document.module';
import { ReportModule } from './report/report.module';
import { ProfileModule } from './profile/profile.module';
import { ProductModule } from './product/product.module';
import { SearchModule } from './search/search.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SaleTaxModule } from './saletax/saletax.module';
import { BillingModule } from './billing/billing.module';
import {TaxReportModule} from './tax-report/tax-report.module';
import {ZipFileModule} from './zip-file/zip-file.module';
import {SubmitToRdModule} from './submit-to-rd/submit-to-rd.module';
import {SettingsModule} from './settings/settings.module';
import {TaxB2PModule} from './tax-b2p/tax-b2p.module';
import {BulkTaxReportModule} from './bulk-tax-report/bulk-tax-report.module';
import { EmailDashboardComponent } from './email-dashboard/email-dashboard.component';
import {EmailDashboardModule} from './email-dashboard/email-dashboard.module';
import { ImportDataComponent } from './import-data/import-data.component';
import {ImportDataModule} from './import-data/import-data.module';
import {CoreModule} from '../core/core.module';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {CustomerModule} from './customer/customer.module';
import {SellerModule} from './seller/seller.module';
import {RDSendReportModule} from './rd-send-report/rd-send-report.module';
import {HistoryLogModule} from './history-log/history-log.module';
import { CustomerRequestModule } from './customer-request/customer-request.module';
import { DocumentRequestModule } from './document-request/document-request.module';
import { DocumentApprovalModule } from './document-approval/document-approval.module';
import { DepartmentModule } from './department/department.module';
import { AbbDashboardModule } from './abb-dashboard/abb-dashboard.module';


@NgModule({
  imports: [
    CommonModule,
    DocumentModule,
    ReportModule,
    SearchModule,
    DashboardModule,
    BillingModule,
    SaleTaxModule,
    ProfileModule,
    ProductModule,
    TaxReportModule,
    ZipFileModule,
    SubmitToRdModule,
    SettingsModule,
    TaxB2PModule,
    BulkTaxReportModule,
    EmailDashboardModule,
    ImportDataModule,
    CoreModule,
    FormsModule,
    DropdownModule,
    CheckboxModule,
    CustomerModule,
    SellerModule,
    RDSendReportModule,
    HistoryLogModule,
    CustomerRequestModule,
    DocumentRequestModule,
    DocumentApprovalModule,
    DepartmentModule,
    AbbDashboardModule,
  ],
  declarations: [
  ]
})
export class FeaturesModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/features.module.ts